import React from 'react';
import { IconS24Crown24 } from '@is24/cosma-ui-icons';
import { Indicator } from 'is24-corecss';
export function OneSystemCustomer() {
  return /*#__PURE__*/React.createElement(Indicator, {
    appearance: "label",
    labelColor: "gray",
    labelVariant: "elevated",
    leftIcon: /*#__PURE__*/React.createElement(IconS24Crown24, null)
  }, "Verkaufsprofi");
}